module.exports = __webpack_public_path__ + "assets/adc3bc07e83857772406f150de49d8df.png";